'use client';

import { __assign } from '../../../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useRef, useCallback, useEffect } from 'react';
import ArrowDownIcon from '../../../Images/ArrowDownIcon/index.js';
import CheckTagIcon from '../../../Images/CheckTagIcon/index.js';
import { DEFAULT_INPUT_STYLE, DEFAULT_SELECT_OPTIONS, DEFAULT_REMOVE_ICON_WIDTH, DEFAULT_CHARACTER_WIDTH, DEFAULT_MARGIN_WIDTH, DEFAULT_BORDER_WIDTH, DEFAULT_PADDING_WIDTH, FIXED_WIDTH_OF_INPUT } from '../../constants.js';
import { EVariant } from '../../types.js';
import { SInputContainer, SelectedItem, ItemTag, PlaceHolder, NumberDistricts, RemoveSpan, SingleItem } from './InputContainer.css.js';
import { ELanguage } from '../../../Utils/constants.js';
import { colors } from '../../../Colors/index.js';

var InputContainer = forwardRef(function (props, ref) {
    var placeholder = props.placeholder, isError = props.isError, styleOptions = props.styleOptions, value = props.value, options = props.options, childrenList = props.childrenList, _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, _b = props.langCode, langCode = _b === void 0 ? ELanguage.VI : _b, onClick = props.onClick, onRemoveItem = props.onRemoveItem, selectOptions = props.selectOptions, isDisabledClearValue = props.isDisabledClearValue, markHasValue = props.markHasValue, forResponsive = props.forResponsive;
    var mergedStyleOption = __assign(__assign({}, DEFAULT_INPUT_STYLE), styleOptions);
    var mergedSelectOptions = __assign(__assign({}, DEFAULT_SELECT_OPTIONS), selectOptions);
    var _c = useState(mergedStyleOption.limitDisplay), showLimit = _c[0], setShowLimit = _c[1];
    var _d = useState(false), isStripFirstLabel = _d[0], setIsRequireStripFirstLabel = _d[1];
    var itemTagWrapperRef = useRef(null);
    var _e = useState(0), parentTagsWrapperWidth = _e[0], setParentTagsWrapperWidth = _e[1];
    var getSelectedItemInText = useCallback(function (limit) {
        var _a, _b;
        var selectedItem = (_a = (value &&
            value.map(function (item) {
                var filteredOptions = options.filter(function (optionItem) { return optionItem.id === item.parentId; });
                if (filteredOptions.length === 0) {
                    return {
                        id: -1,
                        name: ''
                    };
                }
                return filteredOptions[0];
            }))) !== null && _a !== void 0 ? _a : [];
        // Filter empty item out of array
        var filteredNotEmpty = selectedItem.filter(function (item) { return item.id !== -1; });
        filteredNotEmpty = filteredNotEmpty.slice(0, limit);
        // Count total text length
        var joinedText = filteredNotEmpty.map(function (item) { return item.name; }).join('');
        return {
            selectedItem: filteredNotEmpty,
            totalLength: (_b = joinedText === null || joinedText === void 0 ? void 0 : joinedText.length) !== null && _b !== void 0 ? _b : 0
        };
    }, [options, value]);
    var calculateDisplayItem = useCallback(function (limit) {
        var _a;
        var _b = getSelectedItemInText(limit), selectedItem = _b.selectedItem, _c = _b.totalLength, totalLength = _c === void 0 ? 0 : _c;
        if (!selectedItem || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            return [0, 0];
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return [0, 0];
        }
        // Calculate width being use
        var totalTextWidth = totalLength * DEFAULT_CHARACTER_WIDTH;
        var totalPaddingWidth = limit * DEFAULT_PADDING_WIDTH;
        var totalMarginWidth = limit > 1 ? (limit - 1) * DEFAULT_MARGIN_WIDTH : 0;
        var totalBorderWidth = limit * DEFAULT_BORDER_WIDTH;
        // calculate total
        var totalWidth = totalTextWidth + totalPaddingWidth + totalBorderWidth + totalMarginWidth + DEFAULT_REMOVE_ICON_WIDTH;
        return [totalWidth, parentTagsWrapperWidth];
    }, [getSelectedItemInText, itemTagWrapperRef, parentTagsWrapperWidth]);
    var updateDisplayItem = useCallback(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
            return;
        }
        var isFit = false;
        var isStripFirstItem = false;
        var calcTotalWidth = 0;
        var calcItemWrapperWidth = 0;
        var limitCount = mergedStyleOption.limitDisplay;
        while (!isFit) {
            var _a = calculateDisplayItem(limitCount), totalWidth = _a[0], itemWrapperWidth = _a[1];
            if (totalWidth === 0 && itemWrapperWidth === 0) {
                isFit = true;
            }
            if (totalWidth < itemWrapperWidth) {
                isFit = true;
                calcTotalWidth = totalWidth;
                calcItemWrapperWidth = itemWrapperWidth;
            }
            else {
                limitCount--;
            }
            if (limitCount <= 0) {
                limitCount = 1;
                isFit = true;
                isStripFirstItem = totalWidth > itemWrapperWidth;
            }
        }
        var displayItemCount = limitCount;
        if (calcTotalWidth >= calcItemWrapperWidth) {
            // minus 1 item
            displayItemCount = (limitCount !== null && limitCount !== void 0 ? limitCount : 2) - 1;
        }
        // Allow to display all
        if (displayItemCount === 0) {
            displayItemCount = 1;
        }
        setShowLimit(displayItemCount);
        setIsRequireStripFirstLabel(isStripFirstItem);
    }, [calculateDisplayItem, value]);
    useEffect(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            // delay 600ms wait for transitions 500ms in searchbar
            if ((_b = (_a = itemTagWrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) {
                setParentTagsWrapperWidth((_d = (_c = itemTagWrapperRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.clientWidth);
            }
        }, 600);
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay) {
            setShowLimit(styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay);
            return;
        }
        updateDisplayItem();
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', updateDisplayItem);
        return function () {
            if (typeof window === 'undefined') {
                return;
            }
            window.removeEventListener('resize', updateDisplayItem);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, value, styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay, itemTagWrapperRef.current]);
    var renderSelectedItem = function () {
        var _a;
        var selectedItem = getSelectedItemInText(showLimit).selectedItem;
        var itemTagList = [];
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 0 && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            itemTagList.push(React__default.createElement(ItemTag, { variant: mergedStyleOption.variant, key: 'item-tag-plus', isHover: false, forResponsive: forResponsive },
                "+",
                value.length - showLimit));
        }
        if ((value && (value === null || value === void 0 ? void 0 : value.length) === 0) || !selectedItem) {
            return (React__default.createElement(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft }, placeholder));
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return (React__default.createElement(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft }, placeholder));
        }
        itemTagList = selectedItem.map(function (item, index) {
            var _a;
            var filteredValue = value === null || value === void 0 ? void 0 : value.filter(function (valueItem) {
                return valueItem.parentId === item.id;
            });
            var countChild = 0;
            if (filteredValue && (filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) > 0) {
                countChild = filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length;
            }
            // get number districts
            var numberDistricts;
            var province = value === null || value === void 0 ? void 0 : value.find(function (_a) {
                var parentId = _a.parentId;
                return parentId === item.id;
            });
            if (province && province.childrenIds[0] !== -1) {
                numberDistricts = province.childrenIds.length;
            }
            var itemLabel = item.name;
            if ((selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isStripFirstItem) && isStripFirstLabel) {
                var totalTextWidth = item.name.length * DEFAULT_CHARACTER_WIDTH;
                var inputWidth = (((_a = itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) -
                    (DEFAULT_REMOVE_ICON_WIDTH + DEFAULT_MARGIN_WIDTH + DEFAULT_BORDER_WIDTH);
                if (value && value.length > 1) {
                    inputWidth -= FIXED_WIDTH_OF_INPUT;
                }
                var isSplit = itemLabel.length > mergedSelectOptions.limitFirstItemLength;
                if (isSplit && totalTextWidth > inputWidth) {
                    itemLabel = itemLabel.slice(0, mergedSelectOptions.limitFirstItemLength) + '...';
                }
            }
            return (React__default.createElement(ItemTag, { key: "item-tag-".concat(index), "data-selected-child-count": countChild, variant: mergedStyleOption.variant, isDisabledClearValue: isDisabledClearValue, isHover: true, forResponsive: forResponsive },
                React__default.createElement("span", null, itemLabel),
                !!numberDistricts && (React__default.createElement(NumberDistricts, null, (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.variant) === EVariant.SECONDARY ? "(".concat(numberDistricts, ")") : numberDistricts)),
                !isDisabledClearValue ? (React__default.createElement(RemoveSpan, { onClick: function (e) {
                        e.stopPropagation();
                        onRemoveItem(item.id);
                    } },
                    React__default.createElement(CheckTagIcon, null))) : null));
        });
        if (value && (value === null || value === void 0 ? void 0 : value.length) > showLimit) {
            itemTagList.push(React__default.createElement(ItemTag, { variant: mergedStyleOption.variant, key: 'item-tag-plus', isHover: false, forResponsive: forResponsive },
                "+",
                value.length - showLimit));
        }
        return itemTagList;
    };
    var renderSingleSelectItem = function () {
        var placeHolderComponent = React__default.createElement(SingleItem, { className: 'placeholder' }, placeholder);
        if (!value || (value && (value === null || value === void 0 ? void 0 : value.length) === 0)) {
            return placeHolderComponent;
        }
        if (value[0].childrenIds.length === 0) {
            return placeHolderComponent;
        }
        var selectedParentId = value[0].parentId;
        var selectedChildId = value[0].childrenIds[0];
        // Find child item by selected id
        var keys = Object.keys(childrenList);
        var values = Object.values(childrenList);
        var index = keys.indexOf(selectedParentId.toString());
        var childItems = values[index];
        if (!childItems) {
            return placeHolderComponent;
        }
        var childItemInfo = childItems.filter(function (item) { return item.id === selectedChildId; });
        if (childItemInfo.length === 0) {
            return placeHolderComponent;
        }
        return React__default.createElement(SingleItem, null, langCode === ELanguage.VI ? childItemInfo[0].name : childItemInfo[0].nameEn);
    };
    var leftIcon = function () {
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon) {
            var Icon = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon;
            return (React__default.createElement(Icon, { color: value && value.length > 0 ? colors.primary[30] : undefined, width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }));
        }
        return null;
    };
    return (React__default.createElement(SInputContainer, { isError: isError, isDisabled: isDisabled, isPlaceholder: true, onClick: function () { return onClick && onClick(); }, isTransparentBackground: mergedStyleOption.isTransparentBackground, variant: mergedStyleOption.variant, ref: ref, className: 'tree-select-input', markHasValue: markHasValue, forResponsive: forResponsive },
        mergedStyleOption.variant === EVariant.SECONDARY ? leftIcon() : null,
        React__default.createElement(SelectedItem, { ref: itemTagWrapperRef }, mergedSelectOptions.isSingleSelect ? renderSingleSelectItem() : renderSelectedItem()),
        mergedStyleOption.variant === EVariant.PRIMARY && (React__default.createElement(ArrowDownIcon, { width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }))));
});

export { InputContainer as default };
//# sourceMappingURL=index.js.map
